import "../scss/styles.scss";
import $ from "jquery";
import svg4everybody from "svg4everybody";
import "jquery-ui-bundle";

import {
  privacyWireVW,
  privacyWireCustomHandler,
} from './components/privacyWireVW';

$(window).on("load", function () {
  $("body").addClass("window-loaded");
});

//document ready
$(function () {
  window.privacyWireCustomHandler = privacyWireCustomHandler;
  //run SVG for Everybody
  svg4everybody();

  //primary-nav toggle -  mobile burger
  $(".nav-toggle").on("click", function () {
    $("html").toggleClass("js-mobile-menu--is-active");
    $(".header__navigation").slideToggle(400);
  });

  // show / hide resdiary online reservations
  $(".resdiary__widget-show-hide").on("click", function () {
    $("body").toggleClass("js-resdiary__widget--is-active");
  });

  //hide resdiary online reservation
  $(".resdiary__widget-close").on("click", function () {
    $("body").removeClass("js-resdiary__widget--is-active");
  });

  //Resize
  $(window).on("resize", function () {
    //reset mobile nav on resize
    $(".header__navigation").css("display", "");
    $("html").removeClass("js-mobile-menu--is-active");
  });

  //Home hero panel scroll to
  $(".hero-panel__scroll").click(function () {
    var targetOffset = $(".header-intro__page-container").offset().top - 40;
    $("html,body").animate(
      {
        scrollTop: targetOffset,
      },
      1000
    );
    return false;
  });

  //Menu Tabs
  $(function () {
    $("#menu-tabs").tabs();
  });

  //floating labels
  (function () {
    $(".floating-label")
      .find("input")
      .each(function () {
        $(this).on("change", function () {
          var $this = $(this);
          if (this.value !== "") {
            $this.addClass("filled");
          } else {
            $this.removeClass("filled");
          }
        });
      });
  })();

  //newsletter footer subscribe reveal more form inputs
  $(".footer-newsletter #fieldEmail").on("focus", function () {
    //$('.footer-newsletter__reveal').delay(600).slideDown('slow');
    $(".footer-newsletter__reveal").slideDown("slow");
  });

  //responsive tables
  $(".responsive-table").each(function () {
    var thetable = $(this);
    $(this)
      .find("tbody td")
      .each(function () {
        $(this).attr(
          "data-heading",
          thetable
            .find("thead th:nth-child(" + ($(this).index() + 1) + ")")
            .text()
        );
      });
  });

  //***************************************************************************

  // Alert Banner
  // Mobile Check
  function isMobile() {
    var winWidth = $(window).outerWidth(),
      mobileNav = false;

    if (winWidth < 768) {
      mobileNav = true;
    } else {
      mobileNav = false;
    }

    return mobileNav;
  }

  // Get Alert Banner Height
  function alertBannerHeight() {
    var bannerHeight = "";

    if ($(".alert-banner").length) {
      bannerHeight = $(".alert-banner").outerHeight();
    }

    return bannerHeight;
  }

  //***************************************************************************

  //Alert Banner - User Close for their session. If the message changes during the session, the banner will display.

  const alertSection = document.querySelector("#alert-banner");

  //Only run if Alert Banner is ON
  if (alertSection != null) {
    const alertClose = document.querySelector(".alert-close");
    const alertBanner = document.querySelector(".alert-banner");
    //const navLinks = document.querySelector('.nav__links');

    //If user closes the Alert Banner
    //status in storage
    sessionStorage.getItem("alertbanner-status");
    let sessionStatusGet = sessionStorage.getItem("alertbanner-status");

    //status updated if changed by user
    sessionStorage.setItem("alertbanner-status", "banner-show");
    let sessionStatusSet = sessionStorage.getItem("alertbanner-status");

    //If message changes during someone's session we need to force the banner to show, even if the user has closed it
    //content in storage
    sessionStorage.getItem("alertbanner");
    let sessionContentGet = sessionStorage.getItem("alertbanner");

    //content based on banner message content
    sessionStorage.setItem(
      "alertbanner",
      alertBanner.querySelector(".alert-banner__text").innerHTML
    );
    let sessionContentSet = sessionStorage.getItem("alertbanner");

    //Update storage status if user closes banner
    // eslint-disable-next-line no-inner-declarations
    function setAlertStatus() {
      sessionStorage.setItem("alertbanner-status", "banner-closed");
      alertBanner.classList.remove("show");
    }

    // eslint-disable-next-line no-inner-declarations
    function showAlert() {
      alertBanner.classList.add("show");
    }

    // eslint-disable-next-line no-inner-declarations
    function hideAlert() {
      sessionStorage.setItem("alertbanner-status", "banner-closed");
    }

    //Initial load sessionStatusGet and sessionContentGet are null so Show
    //Comparing Get vs Set for alertbanner-status and alertbanner content
    if (
      sessionStatusGet == null ||
      sessionStatusGet == sessionStatusSet ||
      sessionContentGet === null ||
      sessionContentGet != sessionContentSet
    ) {
      showAlert();
    } else {
      hideAlert();
    }

    //User close alert
    alertClose.addEventListener("click", setAlertStatus);
  }

  //***************************************************************************

  function scrollPosition() {
    var currentPosition = $(window).scrollTop();

    $(window).on("scroll", function () {
      currentPosition = $(window).scrollTop();
    });

    return currentPosition;
  }

  scrollPosition();

  // Only update currentPosition if Mobile
  $(window).on("scroll", function () {
    var mobileNav = isMobile();
    if (mobileNav === true) {
      scrollPosition();
    }
  });

  // Set Mobile Header position: relative/fixed;
  // based on alert banner being on
  // #header fixed by default, if alert banner set to relative, then fixed when scroll = alert banner height
  function setMobileNav() {
    var mobileNav = isMobile();
    var bannerHeight = alertBannerHeight();

    if (mobileNav === true && bannerHeight > 0) {
      $("#header").css("position", "relative");
      $("#main").css("padding-top", "0");
    }

    // On Scroll
    $(window).on("scroll", function () {
      var currentPosition = $(window).scrollTop();
      if (mobileNav === true) {
        if (bannerHeight > 0 && currentPosition >= bannerHeight) {
          $("#header").css("position", "fixed");
        }

        if (bannerHeight > 0 && currentPosition < bannerHeight) {
          $("#header").css("position", "relative");
        }
      } else {
        $("#header").css("position", "relative");
        $("#main").css("padding-top", "0");
      }
    });
  }

  setMobileNav();

  $(window).on("resize", function () {
    setMobileNav();
  });

  // Configure/customize these variables.
  var showChar = 125; // How many characters are shown by default
  var ellipsestext = "...";
  var moretext = "More";
  var lesstext = "Less";

  $(".reveal__more").each(function () {
    var content = $(this).html();

    if (content.length > showChar) {
      var c = content.substring(0, showChar);
      var h = content.substring(showChar, content.length - showChar);

      var html =
        c +
        "<span>" +
        ellipsestext +
        '</span><span class="reveal__content"><span>' +
        h +
        '</span><a href="" class="link__reveal">' +
        moretext +
        "</a></span>";

      $(this).html(html);
    }
  });

  $(".link__reveal").on("click", function () {
    if ($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(moretext);
    } else {
      $(this).addClass("less");
      $(this).html(lesstext);
    }
    $(this).parent().prev().toggle();
    $(this).prev().toggle();
    return false;
  });

  privacyWireVW();

  var widgetFrame = $("#rd-widget-frame");
  widgetFrame.load(
    "https://booking.resdiary.com/widget/Mini/Portrait/ThePointeRestaurant/179?includeJquery=false"
  );
});
